package team.platforma.materialextension.theme

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import team.platforma.multiplatform_material_extension.calendar.style.CalendarViewStyle
import team.platforma.multiplatform_material_extension.calendar.style.DateStyle
import team.platforma.multiplatform_material_extension.calendar.style.PeriodStyle
import team.platforma.multiplatform_material_extension.ui.chip.style.ExtraInputChipStyle
import team.platforma.multiplatform_material_extension.ui.chip.style.InputChipBorder
import team.platforma.multiplatform_material_extension.ui.chip.style.InputChipColors

class ExtraInputChipTheme {
    fun light() {
        ExtraInputChipStyle.define(
            inputChipColors = InputChipColors(
                selectedContainerColor = Color(0xFF41C4C4),
                containerColor = Color.Transparent,
                labelColor = Color(0xFF76767A),
                selectedLabelColor = Color.White
            ),
            inputChipBorder = InputChipBorder(
                enabled = true,
                selected = true,
                borderColor = Color(0xFF41C4C4),
                selectedBorderColor = Color.Transparent
            ),
            shape = RoundedCornerShape(12.dp)
        )
    }
    fun dark() {
        ExtraInputChipStyle.define(
            inputChipColors = InputChipColors(
                selectedContainerColor = Color(0xFF41C4C4),
                containerColor = Color.Black,
                labelColor = Color(0xFF76767A),
                selectedLabelColor = Color.Transparent
            ),
            inputChipBorder = InputChipBorder(
                enabled = true,
                selected = true,
                borderColor = Color(0xFF41C4C4),
                selectedBorderColor = Color.Transparent
            ),
            chipHeight = 40.dp
        )
    }
}

